module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var types = [
    {text: 'Print - Letter', value: 'letter'},
    {text: 'Print - Legal', value: 'legal'},
    {text: 'Print - Executive',value: 'executive'},
    {text: 'Print - DIN A4',value: 'a4'},
    {text: 'Print - DIN A5',value: 'a5'},
    {text: 'Print - DIN B4',value: 'b4'},
    {text: 'Print - DIN B5',value: 'b5'},
    {text: 'Custom',value: 'custom'}
];
var u = require('util/Util.js').default;

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Appendix Size</span></div>\r\n<div class=\"row prop-detail\">\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel\">&nbsp;</label> \r\n            <div>\r\n                <select name=\"appendixSizePreset\" id=\"appendixSizePreset\">\r\n                    ")
    ;  for (var i = 0; i < types.length; i++) { 
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(types[i].value))
    ; __append("\">")
    ; __append(escapeFn(types[i].text))
    ; __append("</option>\r\n                    ")
    ;  }; 
    ; __append("\r\n                </select>\r\n            </div>\r\n        </div>   \r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 subsection nopadding-r\"> \r\n            <label class=\"prop-sublabel label-35\">Width</label>\r\n            <div>\r\n                <input type=\"text\" class=\"label-65\" name=\"appendixWidth\" value=\"")
    ; __append(escapeFn(u.convertFromPixelToUnit(appendixWidth,appendixDpi,appendixUnit)))
    ; __append("\"></input>\r\n            </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6 subsection nopadding-r\"> \r\n            <label class=\"prop-sublabel label-35\">Unit</label>\r\n            <div>\r\n                <select name=\"appendixUnit\" class=\"label-65\">\r\n                    <option value=\"pixel\">pixel</option>\r\n                    <option value=\"inch\">inch</option>\r\n                    <option value=\"mm\">mm</option>\r\n                    <option value=\"cm\">cm</option>\r\n                    <option value=\"point\">point</option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n        \r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-35\">Height</label>\r\n            <div>\r\n                <input type=\"text\" class=\"label-65\" name=\"appendixHeight\" value=\"")
    ; __append(escapeFn(u.convertFromPixelToUnit(appendixHeight,appendixDpi,appendixUnit)))
    ; __append("\"></input>\r\n            </div>   \r\n        </div>\r\n        <div class=\"col-md-6 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-35\">DPI</label>\r\n            <div>\r\n                <input type=\"text\" class=\"label-65\" name=\"appendixDpi\" value=\"")
    ; __append(escapeFn(appendixDpi))
    ; __append("\"></input>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}